import { MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { useStoreContacts } from '@/entities/contact'
import { chatModel } from '@/entities/messages'

import { getUnknownContactLabel } from '@/shared/utils/contacts'

import { VoicePlayTrack } from '../model/types'

import { isVoiceMessage } from './is-voice-message'

export const collectVoicePlaylist = (pServed: string, youLabel: string): VoicePlayTrack[] => {
  const { findRoomMessages } = chatModel.useChatMessageStore()
  const { findByPServed } = useStoreContacts()

  return findRoomMessages(pServed).flatMap((event) => {
    const item = event.item as MessageIncomingEvent | MessageOutgoingEvent
    if (!isVoiceMessage(item)) return []

    const file = item.files?.[0]
    if (!file) return []

    const isOutgoing = event.item.type === 'OutgoingMessageEvent'
    const fileName = isOutgoing
      ? youLabel
      : findByPServed(item.executor)?.name ?? getUnknownContactLabel(item.executor)

    return [{
      fileCookie: file.filecookie,
      fileName,
      pServed: item.pServed,
      eventId: event.eventId,
    }]
  })
}
